import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import * as actions from '../../../store/actions'
import {connect} from "react-redux";
import Alert from "../../../components/alert";
import {getUserDataFromLocalStorage, onChangeInput, validateInputs, validatePassword} from "../../../services/utils";
import Container from '@material-ui/core/Container';
import {Footer, InputRow} from '../../../components'
import 'react-phone-number-input/style.css'
import InputLabel from "@material-ui/core/InputLabel";
import PhoneInput from 'react-phone-number-input'
import Header from './header'
import {useStyles} from "./authStyles";
import axios from "axios";
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import HttpService from "../../../services/http.service";
import ReCAPTCHA from 'react-google-recaptcha';
function SignIn(props) {
  const classes = useStyles();
  const [error, setError] = useState("")
  const [check, setCheck] = useState(false)
  const [success, setSuccess] = useState("")
  const [state, setState] = useState({
    values: {
      email: "",
      ssoId: "",
      password: "",
      showPassword: false
    },
    errors: {
      ssoId: "",
      email: "",
      password: "",
    },
  });
  // Defaults to Pakistan (this marketplace's primary market) rather than
  // blank — geolocation-db.com (used below to refine this) is a third-party
  // call that can be slow, blocked, or fail outright, and leaving this blank
  // makes react-phone-number-input assume +1 (US), producing a phone number
  // that won't match what the user registered with.
  const [country, setCountry] = useState('PK')
  useEffect(() => {
    const {user, loading} = props.authReducer;
    if (getUserDataFromLocalStorage()) {
      props.history.push("/");
    }
  }, []);

  useEffect(() => {
    const {user, error, success, loading} = props.authReducer;
    if (props.authReducer.error) {
      setTimeout(() => {
        props.errorHandlerSuccess();
      }, 8000);
    } else {
      if (!loading && success && props.authReducer.user) {

        setTimeout(() => {
          props.history.push("/");
          props.errorHandlerSuccess();
        }, 1500);
      }
    }
  }, [props.authReducer.error, props.authReducer.user]);

  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/',{ headers: {
        'Content-Type': 'application/json'
      }}).catch(res=>console.log(res))
    console.log("ip ", res && res.data);
    HttpService.setToken(res?.data?.country_code)
    // Only override the 'PK' default if this (third-party, sometimes
    // slow/unreachable) lookup actually returned something usable —
    // otherwise this was silently resetting the phone input's country back
    // to react-phone-number-input's own fallback (+1/US) on every failure.
    if (res?.data?.country_code) {
      setCountry(res.data.country_code)
    }
  }

  useEffect(() => {
    //passing getData method to the lifecycle method
    getData().then()

  }, [])
  const {values, errors} = state;

  const onLogin = (e) => {
    e.preventDefault();
    let {email, password, ssoId} = values;
    const data = {password}
    if (ssoId && ssoId != "") {
      ssoId = ssoId.slice(1)
      data.ssoId = ssoId
    } else
      data.email = email
    let recordedErrors = validateInputs(data);
    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let recordedErrors = {}
      // if (!validateEmail(email)) {
      //   recordedErrors.email = 'Invalid Email';
      // }
      let passwordCheck = validatePassword(password);
      if (passwordCheck) {
        recordedErrors.password = passwordCheck;
      }
      if (Object.keys(recordedErrors).length > 0) {
        setState((prevState) => ({
          ...prevState,
          errors: recordedErrors,
        }));
      } else {
        props.onLoginHandler(data);
      }
    }
  };
  const resetPassword = (e) => {
    e.preventDefault()
    let ssoId = values.ssoId
     ssoId = ssoId.slice(1)
    console.log('reset password')//api/resetPassword/ssoId/923338463331
    try{
     HttpService.post(`api/restPassword/ssoId/${ssoId}`).then((res) => {
      if (res) {
        //  console.log(res.data.messageText)
       // setTopProducts(res.data);
        setSuccess("Password is send to your email address! please check")
          setTimeout(() => {
            setSuccess("")
          }, 8000);
      }
    });
       } catch (error) {
          setError("error in forgot password")
        setTimeout(() => {
          setError("")
        }, 5000);
       }

  }
  const [loginType, setLoginType] = useState('mobile');
  const [pathName, setPathName] = useState(props.location.pathname);
  const signInPathName = '/signIn'
  console.log(pathName);
  return (
    <>
      <Header/>
      <Container component="main" maxWidth="xs" style={{paddingTop: 40}}>
        {((props.authReducer?.error || props.authReducer?.success) && !props.authReducer?.loading) &&
        <Alert type={props.authReducer.error ? 'error' : 'success'}
               message={props.authReducer.error || props.authReducer.success}/>
        }
        {((error || success)) && <Alert type={error ? 'error' : 'success'} message={error || success}/>}

        <div className={classes.paper}>

          <form className={classes.form}>
            <FormControl component="fieldset" className='mb-10'>
              <FormLabel
                component="legend"
                className='mt-5 mb-10'>{pathName === signInPathName ? 'Login With:' : 'Reset Password '}
              </FormLabel>

              {pathName === signInPathName && <RadioGroup
                row
                value={loginType}
                onChange={(e) => {
                  e.preventDefault()
                  setLoginType(e.target.value)
                }}
              >
                <FormControlLabel value={'mobile'} control={<Radio/>} label={'Mobile Number'}/>
                <FormControlLabel value={'email'} control={<Radio/>} label={'Email'}/>

              </RadioGroup>}
            </FormControl>
            {(loginType !== 'email' ) && <div className='full-width p-20'>
              <InputLabel error={errors.ssoId ? true : false}>Phone Number</InputLabel>
              <PhoneInput
                international
                style={{border: 'none'}}
                className='country-number'
                placeholder="Enter phone number"
                value={values.ssoId}
                // value={'PK'}
                onChange={(value, key) => {
                  console.log(value, key)
                  onChangeInput(value, `ssoId`, state, setState)
                }}
                // onCountryChange={(e) => console.log(e)}
                defaultCountry={country}
              />
            </div>}

            {(loginType == 'email') &&
            <div className='mt-10'><InputRow
              types={[
                {type: 'email', value: values.email, error: errors.email, label: 'email'},
              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={1}
            /></div>}
            {/* {pathName !== signInPathName &&*/}
            {/*<div className='mt-10'><InputRow*/}
            {/*  types={[*/}
            {/*    {type: 'ssoId', value: values.ssoId, error: errors.ssoId, label: 'Phone Number',id:"ssoId"},*/}
            {/*  ]}*/}
            {/*  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}*/}
            {/*  numOfInputPerRow={1}*/}
            {/*/></div>}*/}

            {pathName === signInPathName && <div className='mt-10'>
              <InputRow
                types={[
                  {type: 'password', value: values.password, error: errors.password, label: 'password', maxLength: 20},
                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={1}
              />
            </div>
            }

            <Grid container spacing={2} className='mt-20 mb-20 pl-10  pr-10'>
          {pathName != signInPathName &&
            <ReCAPTCHA
              sitekey="6LdQQT8eAAAAAF-CoOqoAVxGyR0_Ts1y9Ju1D-YY"
              onChange={(value)=>{setCheck(true)}}
                />
           }
              <Grid item lg={12} xs={12}>
               {pathName === signInPathName && <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={ onLogin}
                >
                  {'Sign In'}
                </Button>
                }
                {pathName != signInPathName && check && <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={resetPassword}
                >
                  {"submit"}
                </Button>
                }
              </Grid>
              {false && <>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    href="https://www.agrilivemarket.com/useApplication"
                    className={classes.fbBtn}
                    // onClick={() => googleLogin()}
                  >
                    register with
                    <span className='font-16 text-bold ml-5 text-lowercase'>{'  '} f</span>
                  </Button>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    href="https://www.agrilivemarket.com/AI-Agri/googleAuth"
                    className={classes.googleBtn}
                  >
                    register with
                    <span className='font-16 text-bold ml-5'>{'  '} G+</span>
                  </Button>
                </Grid>
              </>}
            </Grid>
            <Grid container>
              <Grid item xs>
                {pathName === signInPathName ? <Link href="/reset-password" variant="body2" className='heading-color'>
                    Forgot password?
                  </Link> :
                  <Link href="/signIn" variant="body1" className='heading-color'>
                    Back to login
                  </Link>}
              </Grid>
              <Grid item>
                <Link href="/signup" variant="body1" className='heading-color'>
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </form>
        </div>

      </Container>
      <Footer auth={true}/>
    </>
  );
}

const mapStateToProps = ({authReducer}) => {
  return {authReducer};
};
const mapDispatchToProps = (dispatch) => {
  return {
    onLoginHandler: (data) => dispatch(actions.loginStart(data)),
    errorHandlerSuccess: () => dispatch(actions.loginErrorHandlerSuccess()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignIn);

// https://api.ipify.org/?format=json get ip
// http://www.geoplugin.net/json.gp?ip=202.69.61.98 get country from ip
